import { AuthSessionRepository } from '../repositories/AuthSessionRepository';
import { AuthSession } from '../domain/entities/AuthSession';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { TOKEN_TYPE } from '../constants/constants';

export class SetGuestAuthSessionUseCase {
    private authSessionRepository: AuthSessionRepository;
    private authSession: AuthSession;

    constructor() {
        this.authSessionRepository = diContainer.get(serviceNames.authSessionRepository);
        this.authSession = diContainer.get(serviceNames.authSession);
    }

    public execute = async () => {
        try {
            const response = await this.authSessionRepository.getGuestToken();
            const authSession = new AuthSession(
                response.access_token,
                TOKEN_TYPE.GUEST,
                response.expires_in
            );
            this.authSession.updateAuthSession(authSession);
        } catch (error) {
            throw error;
        }
    };
}
